import { API_EXPORT_PRE_ORDER, API_SCHEDULE_ORDER_NOTI, API_SCHEDULE_ORDER_PUSH_NOTI } from '../constants/api'
import axios from '../utils/axios'

export const getListOrder = (body) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`pl-ts/api/plg/v1/seller/order/list`, body)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        }
        reject(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export const getTotalOrder = (body) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`pl-ts/api/plg/v1/seller/order/total`, body)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        }
        reject(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export const getDetailOrder = (orderNo) => {
  const url = `pl-ts/api/plg/v1/seller/order/${orderNo}`
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        }
        reject(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export const updateDetailOrder = (body) => {
  const url = 'pl-ts/api/plg/v1/seller/order'
  return axios.put(url, body)
}

// Tìm lại tài xế Ahamove khi đơn giao thất bại/bị hủy
export const findAhamove = async ({ orderCode, deliveryType }) => {
  const url = 'pl-ts/api/plg/v1/seller/order/find-ahamove'
  const response = await axios.put(url, { orderCode, deliveryType })

  if (response?.status !== 200) {
    throw response?.data || response
  }

  const result = response?.data

  return {
    status: result?.status ?? result?.Status,
    message: result?.message ?? result?.Message,
  }
}

// Yêu cầu hoàn tiền cho đơn hàng đã hủy
export const refundRequestOrder = (orderCode) => {
  const url = 'pl-ts/api/plg/v1/seller/order/refund-request'
  return axios.put(url, { orderCode })
}

export function printOrder(input) {
  return new Promise((resolve, reject) => {
    axios
      .post('pl-ts/api/plg/v1/seller/order/print', input)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        }
        reject(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getScheduleOrderNotification() {
  return axios.get(API_SCHEDULE_ORDER_NOTI)
}

export const pushScheduleOrderNotification = ({ orderCode, body }) => {
  const url = API_SCHEDULE_ORDER_PUSH_NOTI + '?orderCode=' + orderCode
  return axios.post(url, body)
}
export const exportPreOrder = (body) => {
  return axios.post(API_EXPORT_PRE_ORDER, body, {
    responseType: 'blob',
  })
}
